import PropTypes from 'prop-types';
import { usePermissions, useTranslate } from 'react-admin';
import CustomShowModalButton from '@/components/global/buttons/CustomShowModalButton.jsx';
import { useDrawer } from '@/composables/useDrawer';
import { canViewDeviceConfig } from '@/helpers/device/deviceConfig.js';

export const ShowDeviceConfigButton = ({ id, label }) => {
    const { permissions } = usePermissions();
    const { openDrawer } = useDrawer();
    const translate = useTranslate();

    if (!id || !canViewDeviceConfig(permissions)) {
        return null;
    }

    return <CustomShowModalButton onOpen={() => openDrawer(id, 'device-config')} label={label || translate('resources.device.labels.showConfiguration')} />;
};

ShowDeviceConfigButton.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
};
